import axios from 'axios';
import { getApiKey } from './localStorage';

const BRANDFOLDER_URL = 'https://brandfolder.com/api/v4';

export const getAttachmentsForAsset = assetId => {
  return axios
    .get(`${BRANDFOLDER_URL}/assets/${assetId}/attachments`, {
      headers: {
        Authorization: `Bearer ${getApiKey()}`,
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      return response.data.data.map(attachment => ({
        id: attachment.id,
        attributes: attachment.attributes,
        asset: {
          id: assetId
        }
      }));
    });
};



// WEBPACK FOOTER //
// ./src/services/attachment.js